import React, { useEffect } from 'react';
import LogRocket from 'logrocket';

import NavBar from './components/NavBar';
import RouterProvider from './Routes';
import AlertDisplay from './components/AlertDisplay';

import { clearAuthCookies } from './utils';
import { getTenantFromUrl, getThemeConfig } from './utils/tenant';

import './App.scss';

export default function App() {
  const useLogRocket = process.env.REACT_APP_USE_LOG_ROCKET === 'true';
  const hostname = window.location.hostname;
  const cookieDomain = hostname === 'localhost'? hostname : hostname.split('.').slice(-2).join('.');
  console.log('cookieDomain app', cookieDomain);
  if (useLogRocket) LogRocket.init(process.env.REACT_APP_LOG_ROCKET_APP_ID, {
    rootHostname: cookieDomain,
    // rootHostname: process.env.REACT_APP_COOKIE_STORAGE_DOMAIN,
    mergeIframes: true,
  });

  useEffect(() => {
    // Set document title and favicon based on tenant
    const tenant = getTenantFromUrl();
    const theme = getThemeConfig(tenant);
    document.title = theme.title || 'Valuation Software';

    // Update favicon
    if (theme.favicon) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = `${process.env.PUBLIC_URL}/${theme.favicon}`;
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }, []);

  useEffect(() => {
    // Clear auth cookies on initial load
    const params = new URLSearchParams(window.location.search);
    const portalSwitch = params.get('portal-switch');

    if (portalSwitch !== '1') {
      clearAuthCookies();
    }
  }, []);

  return (
    <div className="App">
      <AlertDisplay />
      <NavBar />
      <RouterProvider />
    </div>
  );
}
